var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Mechanic50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M24,32L24,32l-5,1l-5-1c0,0-11,1.986-11,13h32C35,34.025,24,32,24,32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M19 38L14 32 14 26 24 26 24 32z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9a825",
    d: "M30,20c0,1.106-0.896,2-2,2c-1.106,0-2-0.894-2-2c0-1.105,0.894-2,2-2C29.104,18,30,18.895,30,20 M12,20c0-1.105-0.896-2-2-2c-1.106,0-2,0.895-2,2c0,1.106,0.894,2,2,2C11.104,22,12,21.106,12,20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb74d",
    d: "M28,14c0-7.635-18-4.971-18,0v7c0,4.971,4.028,9,9,9c4.971,0,9-4.029,9-9V14z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M19,5C12.925,5,9,9.926,9,16v2.286L11,20v-5l12-4l4,4v5l2-1.742V16c0-4.025-1.038-8.016-6-9l-1-2H19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#784719",
    d: "M22,20c0-0.551,0.448-1,1-1s1,0.449,1,1s-0.448,1-1,1S22,20.551,22,20 M14,20c0,0.551,0.448,1,1,1 s1-0.449,1-1s-0.448-1-1-1S14,19.449,14,20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#283593",
    d: "M25,32.254V41H13v-8.749c-0.945,0.28-2.445,0.823-4,1.791V41v2v2h20v-2v-2v-6.941 C27.444,33.086,25.944,32.536,25,32.254z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M13,41L13,41H9l0,0v-3l0,0h4l0,0V41z M29,38L29,38h-4l0,0v3l0,0h4l0,0V38z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M29,14.52v-2.255C29,7.257,24.216,4,19,4l0,0C13.784,4,9,7.257,9,12.265v2.311 c0,0,3.889-2.576,10-2.576S29,14.52,29,14.52z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M13,13h12c0,0-0.5-7.44-5.996-9.416C13.333,5.987,13,13,13,13z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    d: "M19 3A1.333.64 0 1 0 19 4.28 1.333.64 0 1 0 19 3zM19 12c-6 0-8.75 1.669-10 2.52C10 16 10.922 17 11.618 17l0 0c.473 0 1.381-1 7.381-1s6.859 1 7.334 1C27.025 17 28 16 29 14.52 28.028 13.689 25 12 19 12z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "M25.804,44.187c1.2,1.1,3.1,1.1,4.3-0.1c0.1-0.1,3.8-5,5.4-6.3c0.5-0.4,2,0.3,3.8,0.3 c1.1,0,2.3-0.1,3.4-1.2c1.9-1.9,2.7-4.9,2.1-7.5l-4.8,4.7c0,0-1.3,0-2.7-1.3c-1.3-1.4-1.3-2.7-1.3-2.7l4.7-4.7 c-2.5-0.7-5.6,0.2-7.5,2.1c-1.1,1-1.2,2.2-1.2,3.3c0,1.8,0.6,3.3,0.1,3.9c-1.1,1.4-6.1,5.2-6.2,5.3 C24.704,41.187,24.704,43.087,25.804,44.187z M27.004,42.087c0-0.6,0.4-1,1-1s1,0.4,1,1c0,0.6-0.4,1-1,1 S27.004,42.687,27.004,42.087z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mechanic50);
export default __webpack_public_path__ + "static/media/icons8-mechanic-50.f1ddb59b8ab2208bb7ed7a3f949ee85c.svg";
export { ForwardRef as ReactComponent };